import { render, staticRenderFns } from "./KioskTutorial.vue?vue&type=template&id=194889f0&"
import script from "./KioskTutorial.vue?vue&type=script&lang=js&"
export * from "./KioskTutorial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports